<template>
  <div class="EIdConfiguration">
    <div class="third">
      <div class="third-formOne new-xiaoqu">
        <div class="formOne-btn">
          <div class="btn-left"
               style="width:70%">
            <!-- <span class="left-back-content">APP启动配置</span> -->
            <el-menu :default-active="activeIndex"
                     class="third-menu-list"
                     mode="horizontal"
                     @select="handleSelect">
              <!-- <span class="menu-back-icon" @click="goBack">
                <i class="el-icon-arrow-left"></i>
                <span class="menu-back-title">返回</span>
            </span> -->
              <el-menu-item :index="item.code"
                            v-for="(item, index) in titleList"
                            :key="index">{{ item.label }}</el-menu-item>
            </el-menu>
          </div>
          <div class="btn-right"
               style="width:30%">
            <el-button @click="Reset()"
                       class="btn-two"
                       type="default">重置</el-button>
            <el-button @click="Preservation()"
                       class="btn-two"
                       type="primary"
                       v-el-disabel-repeat-click>保存</el-button>
          </div>
        </div>
        <el-form style="display: inline-block; width: 60%; float: left"
                 @validate="validateValue"
                 :show-message="false"
                 :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="86px">
          <div class="formOne-forms">
            <div class="forms-one"
                 style="margin-top: 57px">
              <div class="one-title"
                   v-if="isShow">
                <div class="title-left">
                  <span class="left-icon">
                    <i class="el-icon-s-operation"></i>
                  </span>
                  <span class="left-content">基本信息</span>
                </div>
              </div>
              <div class="one-list list-line"
                   v-if="isShow">
                <div class="list-one-line">
                  <el-form-item label="电子证件名称"
                                prop="showTitle">
                    <el-input disabled
                              :maxlength="10"
                              class="list-input"
                              placeholder="请输入"
                              v-model.trim="ruleForm.showTitle">
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="forms-one"
                   v-if="true">
                <div class="one-title">
                  <div class="title-left">
                    <span class="left-icon">
                      <i class="el-icon-s-operation"></i>
                    </span>
                    <span class="left-content">照片配置</span>
                  </div>
                </div>
                <div class="one-list list-line">
                  <div class="list-one-line">
                    <el-form-item label="照片来源"
                                  prop="picUploadType"
                                  :rules="{
                        required: true,
                        message: `请选择照片来源`,
                        trigger: 'blur',
                      }">
                      <el-radio-group v-model="ruleForm.picUploadType">
                        <el-radio :label="1">本人上传</el-radio>
                        <el-radio :label="2">管理端上传</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="用户照片"
                                  v-if="ruleForm.picUploadType == 2"
                                  prop="picUploadType"
                                  :rules="{
                        required: true,
                        message: `请选择照片来源`,
                        trigger: 'blur',
                      }">
                      <span style="font-size: 12px; color: #76838f">{{`请在《${getTitle(activeIndex)}电子照片管理》中上传${getTitle(activeIndex)}的照片`}}</span>
                    </el-form-item>
                    <el-form-item :label="
                        ruleForm.picUploadType == 1 ? '尺寸要求' : '展示尺寸'
                      "
                                  prop="picSize"
                                  :rules="{
                        required: true,
                        message: `请选择照片尺寸`,
                        trigger: 'blur',
                      }">
                      <el-radio-group v-model="ruleForm.picSize">
                        <el-radio :label="1">1寸</el-radio>
                        <el-radio :label="2">2寸</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="ruleForm.picUploadType == 1"
                                  label="格式要求"
                                  prop="picFileType"
                                  :rules="{
                        required: true,
                        message: `请选择格式要求`,
                        trigger: 'blur',
                      }">
                      <el-checkbox-group v-model="ruleForm.picFileType">
                        <el-checkbox label=".jpg"></el-checkbox>
                        <el-checkbox label=".jpeg"></el-checkbox>
                        <el-checkbox label=".png"></el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="照片说明: "
                                  prop="picUploadTips"
                                  :rules="{
                        required: true,
                        message: `请输入照片说明`,
                        trigger: 'blur',
                      }">
                      <el-input class="list-textarea list-ywInpt"
                                type="textarea"
                                placeholder="请输入"
                                maxlength="3000"
                                show-word-limit
                                v-model="ruleForm.picUploadTips">
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="forms-one">
                <div class="one-title">
                  <div class="title-left">
                    <span class="left-icon">
                      <i class="el-icon-s-operation"></i>
                    </span>
                    <span class="left-content">电子码</span>
                  </div>
                </div>
                <div class="list-one-line">
                  <el-form-item label="条形码"
                                prop="barcodeDispaly"
                                :rules="{
                      required: true,
                      message: `请选择条形码`,
                      trigger: 'blur',
                    }">
                    <el-radio-group v-model="ruleForm.barcodeDispaly">
                      <el-radio :label="1">展示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                  </el-form-item>=
                  <el-form-item label="二维码"
                                prop="qrcodeDisplay"
                                :rules="{
                      required: true,
                      message: `请选择二维码`,
                      trigger: 'blur',
                    }">
                    <el-radio-group v-model="ruleForm.qrcodeDisplay">
                      <el-radio :label="1">展示</el-radio>
                      <el-radio :label="0">隐藏</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div class="one-list">
                  <div class="newTable-add-filed"
                       v-for="(item, index) in ruleForm.list"
                       :key="index">
                    <el-form-item :label="index == 0 ? listname : ''"
                                  :prop="'list.' + index + '.userId'"
                                  :rules="{
                        required: true,
                        message: `请输入电子码`,
                        trigger: 'blur',
                      }">
                      <el-select v-model="item.userId"
                                 placeholder="请选择">
                        <el-option v-for="(it, ind) in options"
                                   :key="ind"
                                   :label="it.label"
                                   :value="it.value">
                        </el-option>
                      </el-select>
                      <el-button @click="jia(index)"
                                 v-if="index == '0'"
                                 size="mini"
                                 icon="el-icon-plus"
                                 style="
                          padding: 0;
                          height: 15px;
                          border-color: #3296fa;
                          color: #3296fa;
                        "></el-button>
                      <el-button @click="jian(index)"
                                 v-else
                                 size="mini"
                                 icon="el-icon-minus"
                                 style="
                          padding: 0;
                          height: 15px;
                          border-color: #ff3b30;
                          color: #ff3b30;
                        "></el-button>
                    </el-form-item>
                  </div>

                  <!-- </el-form-item>
              </div> -->
                  <!-- </el-form> -->
                </div>
                <div class="one-list">
                  <el-form-item label="刷新时间"
                                prop="tbzq"
                                :rules="{
                      required: true,
                      message: `请选择刷新时间`,
                      trigger: 'change',
                    }">
                    <el-radio-group v-model="ruleForm.tbzq">
                      <div class="config-radio">
                        <el-form-item class="radio-form-item"
                                      prop="syncOne.seconds"
                                      :rules="{
                            required: true,
                            message: `请输入分`,
                            trigger: 'blur',
                          }">
                          <el-input-number class="radio-input"
                                           v-model="ruleForm.syncOne.seconds"
                                           :min="0"
                                           :max="1440"
                                           placeholder="请输入"
                                           step-strictly
                                           :controls="false"></el-input-number>
                        </el-form-item>
                        <span class="radio-three"> 分 </span>
                        <!-- <el-form-item
                          class="radio-form-item"
                          prop="syncOne.date"
                          :rules="
                            ruleForm.tbzq === 1 && ruleForm.autoSync === true
                              ? {
                                  required: true,
                                  message: `请选择日期时间`,
                                  trigger: 'change'
                                }
                              : {
                                  required: false,
                                  message: `请选择日期时间`,
                                  trigger: 'change'
                                }
                          "
                        >
                          <el-date-picker
                            class="radio-date"
                            v-model="ruleForm.syncOne.date"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            type="datetime"
                            placeholder="选择日期时间"
                          >
                          </el-date-picker>
                        </el-form-item> -->
                        <el-form-item class="radio-form-item"
                                      prop="syncOne.date"
                                      :rules="{
                            required: true,
                            message: `请输入秒`,
                            trigger: 'blur',
                          }">
                          <el-input-number class="radio-input"
                                           v-model="ruleForm.syncOne.date"
                                           :min="0"
                                           :max="60"
                                           placeholder="请输入"
                                           step-strictly
                                           :controls="false"></el-input-number>
                        </el-form-item>
                        <span class="radio-three"> 秒 </span>
                      </div>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </div>
              <div class="forms-one">
                <div class="one-title">
                  <div class="title-left">
                    <span class="left-icon">
                      <i class="el-icon-s-operation"></i>
                    </span>
                    <span class="left-content"
                          v-if="activeIndex == 'TEACHER'">任职信息</span>
                    <span class="left-content"
                          v-else-if="activeIndex == 'OTHER'">个人信息</span>
                    <span class="left-content"
                          v-else>学籍信息</span>
                  </div>
                </div>
                <div class="functionConfig-line-notice"
                     style="padding-left: 26px">
                  <el-checkbox v-model="ruleForm.statusDisplay" v-if="false">当前状态</el-checkbox>
                  <el-button @click="addFieldParams"
                             class="add-field"
                             icon="el-icon-plus">添加展示字段</el-button>
                </div>
                <div class="one-list">
                  <div class="list-data-line"
                       v-for="(item, index) in ruleForm.fields"
                       :key="index">
                    <div style="display: inline-block; vertical-align: top">
                      <div class="list-three-line">
                        <el-form-item label="展示名称"
                                      :prop="'fields.' + index + '.displayName'"
                                      :rules="{
                            required: true,
                            message: `请输入展示名称`,
                            trigger: 'blur',
                          }">
                          <el-input class="list-input"
                                    :maxlength="30"
                                    v-model.trim="item.displayName"
                                    placeholder="请输入"></el-input>
                        </el-form-item>
                      </div>
                      <div class="list-three-line">
                        <el-form-item label="值字段"
                                      :prop="'fields.' + index + '.fieldName'"
                                      :rules="{
                            required: true,
                            message: `请选择值字段`,
                            trigger: 'blur',
                          }">
                          <el-select class="list-input"
                                     v-model="item.fieldName"
                                     placeholder="请选择"
                                     @change="updateInputType">
                            <el-option v-for="(item, index) in options"
                                       :key="index"
                                       :value="item.value"
                                       :label="item.label"
                                       :disabled="item.disabled"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div class="list-addField-line">
                        <el-form-item class="addField-line-configItem">
                          <el-checkbox v-model="item.controlDisplay">用户控制线显隐</el-checkbox>
                        </el-form-item>
                      </div>
                    </div>
                    <div style="width: 24px"
                         class="list-addField-delete"
                         @click="removeFieldParams(item)">
                      <el-button icon="el-icon-minus"></el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="forms-one"
                   v-if="isShow">
                <div class="one-title">
                  <div class="title-left">
                    <span class="left-icon">
                      <i class="el-icon-s-operation"></i>
                    </span>
                    <span class="left-content">业务信息</span>
                  </div>
                </div>
                <div class="list-one-line"></div>
              </div>
              <div class="forms-one">
                <div class="one-title">
                  <div class="title-left">
                    <span class="left-icon">
                      <i class="el-icon-s-operation"></i>
                    </span>
                    <span class="left-content">使用说明</span>
                  </div>
                </div>
                <div class="one-list list-line">
                  <div class="list-one-line">
                    <el-form-item label="标题: ">
                      <el-input :maxlength="30"
                                class="list-input"
                                placeholder="请输入"
                                v-model.trim="ruleForm.tipsTitle"></el-input>
                    </el-form-item>
                    <el-form-item label="内容: ">
                      <el-input class="list-textarea list-ywInpt"
                                type="textarea"
                                placeholder="请输入"
                                maxlength="600"
                                show-word-limit
                                v-model="ruleForm.tipsContent">
                      </el-input>
                      <!-- <el-input
                        class="list-textarea"
                        style="width: 316px"
                        type="textarea"
                        placeholder="请输入"
                        maxlength="600"
                        v-model="ruleForm.tipsContent"
                      ></el-input> -->
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
        <div class="phon-right">
          <img class="phon-right-img"
               src="@/assets/dzzj.png"
               alt="tu" />
          <!-- <img class="phon-right-img" src="" alt="tu" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { addxuexiao, selectxuexiao } from "@/api/baseData/xuexiao";
import {
  pullDownOption,
  EIdCode,
  save,
} from "@/store/appconfig/EIdConfiguration"; //我的
import { cloneDeep } from "lodash";
export default {
  name: "formSeven",
  props: ["IDlist"],
  data () {
    return {
      isShow: false, //隐藏暂时不实现先功能
      countNum: 1, // 只显示第一条错误信息
      activeIndex: "NEW_STUDENT", //选择学生类型
      titleList: [
        {
          label: "新生",
          code: "NEW_STUDENT",
        },
        {
          label: "在校生",
          code: "STUDENT",
        },
        {
          label: "毕业生",
          code: "GRADUATE_STUDENT",
        },
        {
          label: "教工",
          code: "TEACHER",
        },
        {
          label: "其他用户",
          code: "OTHER",
        },
      ],
      rules: {
        showTitle: [
          { required: true, message: "请输入电子证件名称", trigger: "blur" },
        ],
        picDispaly: [
          { required: true, message: "请选择是否展示", trigger: "change" },
        ],
      },
      ruleForm: {
        id: "",
        showTitle: "1",
        tbzq: true,
        picDispaly: 1,
        picSize: 1,
        picCanEdit: 1,
        barcodeDispaly: 1,
        qrcodeDisplay: 1,
        statusDisplay: true,
        fields: [],
        picUploadTips: "", //照片说明
        picUploadType: 1, //照片来源
        picFileType: [], //照片格式
        list: [
          {
            userId: "",
          },
        ],
        tipsContent: "",
        tipsTitle: "",
        deleteConfig: [], // 删除的信息已存在的配置
        syncOne: {
          seconds: 1,
          date: 0,
        }, // 同步周期一
      },
      listname: "电子码内容",
      sonRefresh: true,
      placeholder: "请输入教工姓名后选择",
      options: [],
      value: "",
      inputTypeList: [
        {
          value: "TEXT",
          label: "文本输入框",
        },
        {
          value: "PHONE",
          label: "文本输入框(手机号)",
        },
        {
          value: "MAIL",
          label: "文本输入框(邮箱)",
          disabled: false,
        },
        {
          value: "RADIO",
          label: "单选框",
        },
        {
          value: "PERSON_PHOTO",
          label: "个人照片(20M以内)",
          disabled: false,
        },
        {
          value: "UPLOAD",
          label: "上传图片(20M以内)",
        },
        {
          value: "SELECTION_BOX",
          label: "省市县下拉选择框",
        },
        {
          value: "TIME_SELECTOR",
          label: "时间选择器(年月日时分）",
        },
        {
          value: "TIME_SLOT_SELECTOR",
          label: "时间段选择器(年月日分）",
        },
      ],
    };
  },
  created () {
    this.pullDownOption();
    this.EIdCode();
  },
  computed: {
    messageData () {
      return JSON.parse(JSON.stringify(this.ruleForm.list));
    },
    directorId () {
      let arr = [];
      this.ruleForm.list.forEach((item) => {
        arr.push(item.userId);
      });
      return arr.join(",");
    },
    fields () {
      let arr = [];
      this.ruleForm.fields.forEach((item) => {
        arr.push(item.userId);
      });
      return arr.join(",");
    },
    isRequiredSize () {
      if (this.ruleForm.picDispaly) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
  methods: {
    //获取title
    getTitle (index) {
      const aaa = this.titleList.find((item) => {
        return item.code == index
      })
      return aaa.label
    },
    //获取下拉菜单数据
    pullDownOption () {
      try {
        pullDownOption({
          dataType:
            this.activeIndex == "GRADUATE_STUDENT"
              ? "STUDENT"
              : this.activeIndex,
        }).then((res) => {
          const data = res.data;
          console.log("获取到了默认图", data);
          if (data.status === 1000) {
            console.log(data.result);
            const obj = cloneDeep(data.result);
            let arr1 = [];
            obj.forEach((item) => {
              arr1.push({
                value: item.fieldName,
                label: item.fieldRemark,
              });
            });
            console.log(arr1, "111");
            this.options = arr1;
          } else {
            this.$message({
              type: "error",
              message: data.msg,
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //初始化页面
    EIdCode () {
      try {
        EIdCode({
          identity: this.activeIndex,
        }).then((res) => {
          const data = res.data;
          console.log("获取到了默认图", data);
          if (data.status === 1000) {
            console.log(data.result);
            const obj = cloneDeep(data.result);
            // console.log(data.result);
            // const ids =cloneDeep(obj.id)
            // debugger
            // const aaa =obj.id
            //  this.ruleForm.ids = data.result.id.toString()

            (this.ruleForm.id = obj.id ? obj.id : ""),
              (this.ruleForm.picDispaly = obj.picDisplay),
              (this.ruleForm.picSize = obj.picSize),
              (this.ruleForm.picCanEdit = obj.picCanEdit),
              (this.ruleForm.barcodeDispaly = obj.barcodeDisplay),
              (this.ruleForm.qrcodeDisplay = obj.qrcodeDisplay),
              (this.ruleForm.picUploadTips = obj.picUploadTips),
              (this.ruleForm.picUploadType = obj.picUploadType),
              (this.ruleForm.picFileType = obj.picFileType.split(",")),
            //   (this.ruleForm.statusDisplay =
            //     obj.statusDisplay == 1 ? true : false),
              (this.ruleForm.tipsTitle = obj.tipsTitle),
              (this.ruleForm.tipsContent = obj.tipsContent);
            let toIs = {
              1: true,
              2: false,
            };
            obj.infoFieldList.map(function (item) {
              var controlDisplay = item.controlDisplay;
              item.controlDisplay = toIs[controlDisplay]
                ? toIs[controlDisplay]
                : controlDisplay;
              return controlDisplay;
            });
            // obj.contentFieldList = "zw_cj,bylb,bczh";
            let arr = obj.contentFieldList.split(",");
            let arrTwo = [];
            arr.forEach((element) => {
              let obj = {
                userId: element,
              };
              arrTwo.push(obj);
            });
            this.ruleForm.list = arrTwo;
            // for (var i = 0; i < obj.infoFieldList.length; i++) {
            //   obj.infoFieldList[i].controlDisplay = obj.infoFieldList[i]
            //     .controlDisplay==1
            //     ? true
            //     : false;
            // }
            this.ruleForm.fields = obj.infoFieldList;
            let arr2 = obj.codeFreshTime.split(",");
            this.ruleForm.syncOne.seconds = Number(arr2[0]);
            this.ruleForm.syncOne.date = Number(arr2[1]);
            console.log(obj.infoFieldList);
          } else {
            this.$message({
              type: "error",
              message: "获取电子证件配置失败",
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //学籍信息代码

    // 新增字段
    addFieldParams () {
      let obj = {
        displayName: "",
        controlDisplay: false,
        fieldName: "",
      };
      if (this.ruleForm.fields.length < 9) {
        this.ruleForm.fields.push(obj);
        console.log(this.ruleForm.fields);
      } else {
        this.$message.error("最多可添加9个字段");
      }
    },
    //选择输入类型
    updateInputType () {
      const fieldsVal = this.ruleForm.fields;
      if (fieldsVal === null) {
        return;
      }
      this.fliterEmailAndPH(fieldsVal);
    },
    // 过滤邮箱和个人照片选项
    fliterEmailAndPH (fieldsVal) {
      const index = this.inputTypeList.findIndex(
        (fruit) => fruit.value === "MAIL"
      );
      const indexPH = this.inputTypeList.findIndex(
        (fruit) => fruit.value === "PERSON_PHOTO"
      );
      // console.log("index--------------------",index);
      if (index !== -1) {
        for (let i = 0; i < fieldsVal.length; i++) {
          if (fieldsVal[i] != null && fieldsVal[i].fieldName === "MAIL") {
            this.inputTypeList[index].disabled = true;
            break;
          }
          this.inputTypeList[index].disabled = false;
        }
      }
      if (indexPH !== -1) {
        for (let i = 0; i < fieldsVal.length; i++) {
          if (
            fieldsVal[i] != null &&
            fieldsVal[i].fieldName === "PERSON_PHOTO"
          ) {
            this.inputTypeList[indexPH].disabled = true;
            break;
          }
          this.inputTypeList[indexPH].disabled = false;
        }
      }
    },
    //电子码区域代码

    // 移除字段
    removeFieldParams (item) {
      // console.log(item)
      if (item.id && this.ruleForm.deleteConfig.indexOf(item) === -1) {
        this.ruleForm.deleteConfig.push(item);
      }
      this.ruleForm.fields.splice(this.ruleForm.fields.indexOf(item), 1);
      this.updateInputType();
      // console.log(this.ruleForm.fields)
      // console.log(this.ruleForm.deleteConfig)
    },
    //  添加一个校区负责人
    jia () {
      if (this.ruleForm.list.length < 9) {
        this.ruleForm.list.push({
          userId: "",
        });
      } else {
        this.$message.error("最多可添加9个字段");
      }
    },
    // 去掉一个校区负责人
    jian (index) {
      this.ruleForm.list.splice(index, 1);
      // console.log(this.list[index]);
    },
    //选择菜单
    handleSelect (value) {
      //   this.formName = value;
      console.log(value);
      this.options = [];
      this.activeIndex = value;
      this.$refs.ruleForm.resetFields();
      this.$refs.ruleForm.clearValidate();
      (this.ruleForm = {
        id: "",
        showTitle: "1",
        tbzq: true,
        picDispaly: 1,
        picSize: 1,
        picCanEdit: 1,
        barcodeDispaly: 1,
        qrcodeDisplay: 1,
        statusDisplay: true,
        fields: [],
        picUploadTips: "", //照片说明
        picUploadType: 1, //照片来源
        picFileType: [], //照片格式
        list: [
          {
            userId: "",
          },
        ],
        tipsContent: "",
        tipsTitle: "",
        deleteConfig: [], // 删除的信息已存在的配置
        syncOne: {
          seconds: 1,
          date: 0,
        }, // 同步周期一
      }),
        this.pullDownOption();
      this.EIdCode();
      // console.log(this.$store.state.user.tenantId,sessionStorage.getItem('user_labelid'))
    },
    //重置
    Reset () {
      (this.ruleForm = {
        id: "",
        showTitle: "1",
        tbzq: true,
        picDispaly: 1,
        picSize: 1,
        picCanEdit: 1,
        barcodeDispaly: 1,
        qrcodeDisplay: 1,
        statusDisplay: true,
        fields: [],
        picUploadTips: "", //照片说明
        picUploadType: 1, //照片来源
        picFileType: [], //照片格式
        list: [
          {
            userId: "",
          },
        ],
        tipsContent: "",
        tipsTitle: "",
        deleteConfig: [], // 删除的信息已存在的配置
        syncOne: {
          seconds: 1,
          date: 0,
        }, // 同步周期一
      }),
        //   this.$refs.ruleForm.resetFields();
        this.$refs.ruleForm.clearValidate();
      this.EIdCode();
    },
    //保存
    Preservation () {
      const Vm = this;
      Vm.countNum = 0;
      Vm.$refs.ruleForm.validate((valid) => {
        if (valid) {
          Vm.countNum = 1;
          // Vm.noticeSpec = '执行开启操作时，系统会自动进行当前功能配置的保存，'
          // Vm.noitceContent = '确定开启吗？'
          // Vm.noticeModal = true
          // Vm.confirm = () => {
          //   return Vm.toSaveForm()
          // }
          //   alert(1111);
          console.log(this.ruleForm.list);
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //   try {
      //   } catch (err) {
      //     console.log(err);
      //   }
    },
    studentInformation (directorId) {
      const repeatArray = directorId.filter((e, i) => {
        //查找电子码内容字段有无重复
        return (
          directorId.indexOf(e) !== directorId.lastIndexOf(e) &&
          directorId.indexOf(e) != i
        );
      });
      return repeatArray;
    },
    save () {
      try {
        console.log(this.directorId, this.ruleForm.list);
        const directorId = this.directorId.split(",");
        const repeatArray = directorId.filter((e, i) => {
          //查找电子码内容字段有无重复
          return (
            directorId.indexOf(e) !== directorId.lastIndexOf(e) &&
            directorId.indexOf(e) != i
          );
        });
        console.log(repeatArray);
        if (repeatArray.length > 0) {
          const repeatField = this.options.filter((a) => {
            return a.value == repeatArray[0];
          });
          this.$message.error(
            `电子码内容[${repeatField[0].label}]字段不可重复`
          );
          return;
        }
        if (
          this.ruleForm.syncOne.seconds * 60 + this.ruleForm.syncOne.date <=
          0
        ) {
          this.$message.error(`电子码刷新时间必须大于0秒`);
          return;
        }
        //&& (this.ruleForm.syncOne.seconds*60+this.ruleForm.syncOne.date)<86400)
        if (
          this.ruleForm.syncOne.seconds * 60 + this.ruleForm.syncOne.date >
          86400
        ) {
          this.$message.error(`电子码刷新时间必须小于1440分钟`);
          return;
        }
        let arr1 = [];
        let arr2 = [];
        this.ruleForm.fields.forEach((it) => {
          arr1.push(it.displayName);
          arr2.push(it.fieldName);
        });
        const reslutArr1 = this.studentInformation(arr1);
        const reslutArr2 = this.studentInformation(arr2);
        if (reslutArr1.length > 0) {
          this.$message.error(`展示名称[${reslutArr1[0]}]不可重复`);
          return;
        } else if (reslutArr2.length > 0) {
          const repeatField = this.options.filter((a) => {
            return a.value == reslutArr2[0];
          });
          this.$message.error(`值字段[${repeatField[0].label}]不可重复`);
          return;
        }
        console.log(this.ruleForm.fields);
        const jsonBig = {};

        let arr = [];
        this.ruleForm.fields.forEach((item) => {
          const json = {
            dcid: this.ruleForm.id,
            userType: this.activeIndex,
          };
          //   debugger
          json.displayName = item.displayName;
          json.fieldName = item.fieldName;
          json.controlDisplay = item.controlDisplay ? 1 : 0;
          arr.push(json);
        });
        jsonBig.infoFieldList = arr;
        jsonBig.id = this.ruleForm.id;
        jsonBig.picCanEdit = this.ruleForm.picCanEdit;
        jsonBig.picDisplay = this.ruleForm.picDispaly;
        jsonBig.picSize = this.ruleForm.picSize;
        jsonBig.qrcodeDisplay = this.ruleForm.qrcodeDisplay;
        jsonBig.picUploadTips = this.ruleForm.picUploadTips;
        jsonBig.picUploadType = this.ruleForm.picUploadType;
        jsonBig.picFileType = this.ruleForm.picFileType.join(",");
        jsonBig.statusDisplay = this.ruleForm.statusDisplay ? 1 : 0;
        jsonBig.tipsContent = this.ruleForm.tipsContent;
        jsonBig.tipsTitle = this.ruleForm.tipsTitle;
        jsonBig.userType = this.activeIndex;
        jsonBig.contentFieldList = this.directorId;
        jsonBig.codeFreshTime =
          this.ruleForm.syncOne.seconds + "," + this.ruleForm.syncOne.date;
        jsonBig.barcodeDisplay = this.ruleForm.barcodeDispaly;

        save(jsonBig).then((res) => {
          const data = res.data;
          console.log("获取到了默认图", data);
          if (data.status === 1000) {
            this.$message.success(data.msg);
            this.EIdCode();
          } else {
            this.$message.error(data.msg);
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 验证
    validateValue (prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //表单验证
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
          this.countNum = 1;
          console.log(this.ruleForm.list);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //表单重置
    async resetForm (formName) {
      await this.selectinfo();
      this.$refs[formName].resetFields();
    },
    //行政区域选中节点
    handleChange (value) {
      console.log(value);
    },
  },
};
</script>

<style lang="scss">
.EIdConfiguration {
  .third .third-menu-list {
    padding: 0;
    .el-menu-item {
      padding: 0 40px;
    }
  }
  .third {
    .new-xiaoqu {
      .formOne-forms {
        .forms-one {
          // .one-list {
          .list-one-line {
            .el-form-item {
              margin-bottom: 10px;
            }
            .list-one-line-list {
              margin-bottom: 10px;
              display: flex;
              align-items: center;
            }
            .text-wenzi {
              .el-form-item__content {
                padding-left: 8px;
              }
            }
          }
          // }
        }
      }
    }
  }
  .new-xiaoqu {
    .onlineComplete-uploadType {
      display: inline-block;
      position: relative;
      margin-right: 8px;
      font-size: 0;
      .onlineComplete-line-notice-icon {
        font-size: 0;
        position: absolute;
        top: -2px;
        left: 86px;
        cursor: pointer;
        padding-left: 4px;
        img {
          width: 16px;
          height: 16px;
        }
      }
      .onlineComplete-canEdit-mark-allConfig {
        pointer-events: auto;
        cursor: pointer;
      }
    }
    .list-data-add {
      padding-bottom: 8px;
      .add-field {
        margin-left: 24px !important;
        padding: 0 276px;
        border: 1px dashed #dcdfe6;
      }
    }
    .list-addField-line {
      display: inline-block;
      vertical-align: top;
      .addField-line-configItem {
        .el-form-item__content {
          margin-left: 16px !important;
        }
        .addField-line-config {
          width: 105px;
          color: #2d8cf0;
          cursor: pointer;
          font-size: 12px;
        }
      }
      .list-input {
        width: 80px !important;
      }
    }
    .list-addField-delete {
      display: inline-block;
      vertical-align: top;
      height: 28px;
      line-height: 28px;
      .el-button {
        width: 16px;
        height: 16px;
        padding: 0;
        color: #ff4d4f;
        border: 1px solid #ff4d4f;
        vertical-align: middle;
      }
    }
    .functionConfig-line-notice {
      font-size: 0;
      color: #2e4057;
      padding-bottom: 12px;
      .line-notice-title {
        display: inline-block;
        font-size: 12px;
        font-weight: bold;
        vertical-align: top;
        height: 20px;
        line-height: 20px;
      }
      .line-notice-icon {
        display: inline-block;
        vertical-align: top;
        height: 20px;
        line-height: 20px;
        cursor: pointer;
        padding-left: 4px;
        img {
          width: 16px;
          height: 16px;
          vertical-align: middle;
        }
      }
    }
    .functionConfig-checkGroup {
      .el-checkbox {
        min-width: 100px;
      }
    }
  }
  .config-radio {
    line-height: 28px;
    // margin-bottom: 8px;
    font-size: 0;
    .radio-form-item {
      display: inline-block;
    }
    .el-input-number__increase {
      right: 1px !important;
    }
    .el-radio__label {
      font-size: 0;
    }
    .radio-one {
      padding-right: 4px;
      font-size: 12px;
    }
    .radio-input {
      width: 72px;
      .el-input__inner {
        text-align: left;
      }
      .el-input-number__decrease {
        right: 1px !important;
      }
    }
    .is-controls-right .el-input__inner {
      padding-right: 29px;
    }
    .radio-time {
      width: 84px;
      margin-right: 4px;
    }
    .radio-select {
      width: 84px;
      margin-right: 4px;
    }
    .radio-date {
      width: 160px;
    }
    .radio-three {
      padding-left: 4px;
      padding-right: 4px;
      font-size: 12px;
    }
  }
  .phon-right {
    position: relative;
    // border:1px solid red;
    width: 40%;
    display: inline-block;
    height: calc(100vh - 102px);
    border-left: 1px solid #dcdee2;
    img {
      // border: 1px solid red;
      padding-top: 32px;
      width: 389px;
      height: 669px;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
}
</style>
